import store from '@/store'

export default [
  {
    path: '/admin/payouts',
    name: 'payout',
    meta: { requiresAuth: true },
    component: () => import('@/pages/accounting/payout')
  },
  {
    path: '/admin/claim-payouts',
    name: 'claim-payout',
    meta: { requiresAuth: true },
    component: () => import('@/pages/accounting/claim-payout')
  }
]
